module.exports = __webpack_public_path__ + "static/media/workspaceRed.8c7bebfa.png";